import { useCallback, useMemo, useState } from "react";
import { message } from "antd";
import { audbilityApi } from "../../shared/services/audbilityApi";
import { normalizeUser } from "../../shared/utils/audbilityFormatters";
import { LOAD_USERS_ERROR_MESSAGE } from "../constants";
import { filterUsersBySearch } from "../utils/audbilityUsersFilters";

export const useAudbilityUsers = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getUsers = useCallback(async () => {
    try {
      setIsLoading(true);

      const apiUsers = await audbilityApi.getUsers();

      setAllUsers(apiUsers.map(normalizeUser));
    } catch (error) {
      console.log("Erro ao buscar usuários Audbility: ", error);
      message.error(LOAD_USERS_ERROR_MESSAGE);
      setAllUsers([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const users = useMemo(
    () => filterUsersBySearch(allUsers, searchTerm),
    [allUsers, searchTerm]
  );

  return {
    users,
    isLoading,
    getUsers,
    searchUsers: setSearchTerm,
  };
};
